import React, { memo } from 'react';
import {
  NotFoundSuggestion,
  SuggestionListItemProduct,
  SuggestionListItemServices,
} from 'components/header/components/searchbar/components';
import { useSuggestionsButtonAction } from 'common/hooks/use-suggestions-button-action';
import type { SuggestionsProps } from './types';
import { SuggestionsList } from './suggestions-list';

export const Suggestions = memo<SuggestionsProps>(
  ({
    searchQuery,
    suggestions,
    suggestionSelector,
    onMouseEnter,
    onMouseLeave,
    searchHref,
    index,
    isSrp,
    onSelectSuggestion,
    notFoundMessage,
  }) => {
    const [slicedProducts, slicedServices] = suggestions ?? [[], []];
    const buttonAction = useSuggestionsButtonAction({
      onMouseEnter,
      onMouseLeave,
      onSelectSuggestion,
      searchQuery,
    });

    if (!suggestions) return null;

    if (slicedProducts.length === 0 && slicedServices.length === 0) {
      if (notFoundMessage === false) {
        return null;
      }
      return (
        <NotFoundSuggestion
          notFoundMessage={notFoundMessage}
          searchHref={searchHref}
          searchQuery={searchQuery}
        />
      );
    }

    return (
      <>
        <SuggestionsList
          suggestionSelector={suggestionSelector}
          withTitle={false}
          title="Товары"
          aria-label="Поиск по товарам">
          {slicedProducts.map((item, idx) => (
            <SuggestionListItemProduct
              productSuggestion={item}
              elementIndex={idx}
              navigationIndex={index}
              searchHref={searchHref}
              buttonAction={buttonAction}
              isSrp={isSrp}
              suggestionSelector={suggestionSelector}
              key={item.phrase}
            />
          ))}
        </SuggestionsList>
        <SuggestionsList
          suggestionSelector={suggestionSelector}
          withTitle={slicedProducts.length > 0}
          withDivider={slicedProducts.length > 0}
          title="Услуги"
          aria-label="Поиск по услугам">
          {slicedServices.map((item, idx) => (
            <SuggestionListItemServices
              servicesSuggestion={item}
              elementIndex={idx}
              navigationIndex={index}
              buttonAction={buttonAction}
              isSrp={isSrp}
              suggestionSelector={suggestionSelector}
              slicedProductsLength={slicedProducts.length}
              key={item.serviceId}
            />
          ))}
        </SuggestionsList>
      </>
    );
  }
);
